import Axios from "axios";
import { QMS } from "../../_constants/actionConstants";
import { BASE_URL } from "../../_constants/urlConstants";
import {
  mapReactFlowEdgesToDto,
  mapReactFlowNodesToDto,
} from "../../_reducers/helpers/qmsWorkflowHelpers";

const qmsWorkflowActions = {
  add: (workflowData) => async (dispatch) => {
    dispatch({ type: QMS.WORKFLOW.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/Workflow";
    try {
      const res = await Axios.post(apiEndpoint, workflowData);
      dispatch({ type: QMS.WORKFLOW.ADD_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.WORKFLOW.ADD_REJECTED });
      logError(e);
    }
  },
  get: (workflowId) => async (dispatch) => {
    dispatch({ type: QMS.WORKFLOW.FETCH });
    const apiEndpoint = BASE_URL + "/api/qms/Workflow/" + workflowId;
    try {
      const res = await Axios.get(apiEndpoint);
      dispatch({ type: QMS.WORKFLOW.FETCH_FULFILLED, workflowId, workflow: res.data });
    } catch (e) {
      dispatch({ type: QMS.WORKFLOW.FETCH_REJECTED });
      logError(e);
    }
  },
  getAll: (divisionId, tabId) => async (dispatch) => {
    dispatch({ type: QMS.WORKFLOW.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/Workflow/List/" + divisionId;
    try {
      const res = await Axios.get(apiEndpoint);
      dispatch({
        type: QMS.WORKFLOW.FETCH_ALL_FULFILLED,
        tabId,
        workflowList: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.WORKFLOW.UPDATE_REJECTED });
      logError(e);
    }
  },
  removeRange: (workflowIds, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.WORKFLOW.REMOVE });
    const apiEndpoint_delete = `${BASE_URL}/api/qms/Workflow`;
    try {
      const delRes = await Axios.delete(apiEndpoint_delete, {
        params: { ids: workflowIds || [] },
        paramsSerializer: (params) => qs.stringify(params),
      });
      if (delRes.data.message) {
        dispatch({ type: QMS.WORKFLOW.REMOVE_REJECTED });
        // Show alert
        alert(delRes.data.message);
      } else {
        const apiEndpoint_getAll = BASE_URL + "/api/qms/Workflow/List/" + divisionId;
        const res = await Axios.get(apiEndpoint_getAll);
        dispatch({
          type: QMS.WORKFLOW.REMOVE_FULFILLED,
          divisionId,
          qmsTeams: res.data,
        });
      }
    } catch (e) {
      dispatch({ type: QMS.WORKFLOW.REMOVE_REJECTED });
      logError(e);
    }
  },
  update: (workflowData) => async (dispatch) => {
    dispatch({ type: QMS.WORKFLOW.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/Workflow";

    const mappedWorkflowData = {
      ...workflowData,
      nodes: mapReactFlowNodesToDto(workflowData.nodes),
      edges: mapReactFlowEdgesToDto(workflowData.edges, workflowData.nodes),
    };

    try {
      const res = await Axios.put(apiEndpoint, mappedWorkflowData);
      dispatch({
        type: QMS.WORKFLOW.UPDATE_FULFILLED,
        divisionId: mappedWorkflowData.divisionId,
        workflows: res.data, // List
      });
    } catch (e) {
      dispatch({ type: QMS.WORKFLOW.UPDATE_REJECTED });
      logError(e);
    }
  },
  getRelationshipTypes: () => async (dispatch) => {
    dispatch({ type: QMS.WORKFLOW.FETCH_RELTYPES });
    const apiEndpoint = BASE_URL + "/api/qms/Workflow/RelationshipTypes";
    try {
      const res = await Axios.get(apiEndpoint);
      dispatch({
        type: QMS.WORKFLOW.FETCH_RELTYPES_FULFILLED,
        relationshipTypes: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.WORKFLOW.UPDATE_REJECTED });
      logError(e);
    }
  },
};

export default qmsWorkflowActions;
